import { useEffect } from 'react'
import { useStore } from '../Components/useStore'
import { fetchProfile } from '../Utils/authApi'
import { mergeProfileFields } from '../Utils/customerProfile'

/** Load full customer profile (orders checkout data) after login or on refresh. */
export default function ProfileBootstrap() {
  const { state, dispatch } = useStore()
  const token = state.UserInfo?.token

  useEffect(() => {
    if (!token) return undefined
    let cancelled = false

    fetchProfile(token)
      .then((profile) => {
        if (cancelled || !profile) return
        dispatch({
          type: 'UserLoggedIn',
          payload: {
            ...state.UserInfo,
            ...mergeProfileFields(state.UserInfo, profile),
            token,
          },
        })
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  return null
}
